module.exports = __webpack_public_path__ + "img/mlt_x_732_735_1035.dd02ebbf.jpg";